export default __webpack_public_path__ + "9ae0084ce239afeacc5b78ab02769437.png";